(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["accessible-carousel"] && !Shopify.designMode) return;
  try {
    
    class AccessibleSlider extends HTMLElement {
        constructor() {
            super();
        }
				connectedCallback() {

						window.addEventListener('load', () => {
                const nav = {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev'
                };
                const scope = this;
								this.swiper = new Swiper(this.querySelector('[data-swiper]'), {
										// Optional parameters
										allowTouchMove: true,
										direction: 'horizontal',
										loop: true,
										spaceBetween:0,
										slidesPerView: 1,
                    autoplay: this.dataset.autoplay === 'true' ? true : false,
										speed: Number(this.dataset.speed),
                    navigation: {
                      nextEl: '.swiper-next',
                      prevEl: '.swiper-prev',
                    },
                    on: {
                      init: function () {
                          const slide = scope.querySelector('.swiper-slide-active .hero');
                          if(slide){
                            let navColor = slide.dataset.arrow
                            scope.querySelector('.swiper-next').style.color = navColor;
                            scope.querySelector('.swiper-prev').style.color = navColor;
                          }
                      },
                    },
								});

                this.swiper.on('slideChangeTransitionStart', function () {
                    const slide = scope.querySelector('.swiper-slide-active .hero');
                    let navColor = slide.dataset.arrow
                    scope.querySelector('.swiper-next').style.color = navColor;
                    scope.querySelector('.swiper-prev').style.color = navColor;
                });

						})
				}
    }
    customElements.define('accessible-carousel', AccessibleSlider);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
window.addEventListener('DOMContentLoaded', () => {
  const headings = document.querySelectorAll('.footer__blocks-wrapper .footer-block__heading_container');

    const handleCollapse = (heading) => {
    const content = heading.nextElementSibling;

      if (heading.classList.contains('block-collapsed')) {
        heading.classList.remove('block-collapsed');
        heading.setAttribute('aria-expanded', 'true');
        content.style.display = 'block'; // or any other preferred display property
      } else {
        heading.classList.add('block-collapsed');
        heading.setAttribute('aria-expanded', 'false');
        content.style.display = 'none';
      }
    };

    headings.forEach((heading, index) => {
    heading.classList.add('block-collapsed');
    heading.setAttribute('role', 'button');
    heading.setAttribute('aria-expanded', 'false');
    heading.setAttribute('tabindex', '0');

    const content = heading.nextElementSibling;
    content.setAttribute('id', `footer-block-index-${index}`);
    heading.setAttribute('aria-controls', `footer-block-index-${index}`);

    heading.addEventListener('click', () => {
      handleCollapse(heading);
    });

    heading.addEventListener('keydown', (event) => {
      if (event.key === 'Enter' || event.key === ' ') {
      handleCollapse(heading);
      }
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
